import { PackagesApi } from '../../api'
import { setPackageCategories, setPackageCategoriesLoading } from '../index'

export const fetchPackageCategories = packageId => {
  return async (dispatch) => {
    try {
      dispatch(setPackageCategoriesLoading(true))
      const api = new PackagesApi()
      const result = await api.getPackageCategories(packageId)

      if (result.error) dispatch(setPackageCategories([]))
      else dispatch(setPackageCategories(result.packageCategories))

      dispatch(setPackageCategoriesLoading(false))
    } catch (e) {
      dispatch(setPackageCategories([]))
      dispatch(setPackageCategoriesLoading(false))
    }
  }
}
